import options from './live-desk-occupancy-card.component';

export default {
    selector: 'dtLiveDeskOccupancyCard',
    options
};
